"use client";

import { useState } from "react";

const TEXT_DIM = "#a0a0a0";
const TEAL = "#4FCDC4";

export default function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (_) {}
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <button
        type="button"
        className="code-block-copy"
        onClick={handleCopy}
        aria-label={copied ? "Code copied to clipboard" : "Copy code to clipboard"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "6px 12px",
          background: "transparent",
          border: `1px solid ${copied ? "rgba(79,205,196,0.5)" : "rgba(255,255,255,0.1)"}`,
          borderRadius: 6,
          color: copied ? TEAL : TEXT_DIM,
          fontSize: 11,
          fontFamily: "var(--mono)",
          fontWeight: 600,
          letterSpacing: "0.04em",
          cursor: "pointer",
          transition: "border-color 120ms ease, color 120ms ease",
          minHeight: 28,
          userSelect: "none",
        }}
      >
        {copied ? "\u2713 Copied" : "Copy"}
      </button>
      <span aria-live="polite" style={{ position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", border: 0 }}>
        {copied ? "Code copied to clipboard" : ""}
      </span>
    </>
  );
}
